// extracted by mini-css-extract-plugin
export default {"button":"CandlePatternButton_button__9Rgcf"};